import React from 'react';

import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

export const MaterialTextField = ({
   label,
   input,
   meta: { touched, invalid, error },
   showHelper,
   ...custom
}) => (
   <>
      <TextField
         label={label}
         error={touched && invalid}
         {...(showHelper ? { helperText: touched && error } : {})}
         {...input}
         {...custom}
      />
   </>
);

export const MaterialCheckbox = ({ input, label, size, className, disabled }) => (
   <div>
      <FormControlLabel
         className={(size === 'small' ? 'MuiFormControlLabel-size-small' : '')}
         control={(
            <Checkbox
               checked={ input.value ? true : false}
               onChange={input.onChange}
               {...(size ? { size: size } : {})}
               className={(className ? className + ' ' : '')}
               disabled={ disabled ? true : false }
            />
         )}
         label={label}
      />
   </div>
);

export const radioButton = ({ input, ...rest }) => (
   <FormControl>
      <RadioGroup {...input} {...rest}>
         <FormControlLabel value='female' control={<Radio />} label='Female' />
         <FormControlLabel value='male' control={<Radio />} label='Male' />
         <FormControlLabel value='other' control={<Radio />} label='Other' />
      </RadioGroup>
   </FormControl>
);

export const MaterialFromHelper = ({ touched, error }) => {
   if (!(touched && error)) {
      return;
   } else {
      return <FormHelperText>{touched && error}</FormHelperText>;
   }
};

export const MaterialSelectField = ({
   input,
   label,
   meta: { touched, error },
   children,
   name,
   id,
   showHelper,
   style,
   className,
   ...custom
}) => (
   <FormControl error={touched && !!error} className={ className ? className : '' }>
      <InputLabel>{label}</InputLabel>
      <Select
         native
         {...input}
         {...custom}
         inputProps={{
            name: name,
            id: id,
         }}
      >
         {children}
      </Select>
   </FormControl>
);

export const GenerateMaterialSelectOptions = ({
   options,
}) => (
   <>
      <option value='' />
      {options.map((item, index) => (
         <option key={index} value={item.value} >{item.label}</option>
      ))}
   </>
);
